import { Cell, Pie, PieChart as RechartsPieChart } from 'recharts';

export interface PieSlice {
  name: string;
  value: number;
  color: string;
}

interface PieChartProps {
  data: PieSlice[];
  size: number;
  // Inner radius as a fraction of the outer radius: 0 = full pie, >0 = donut.
  innerRadiusRatio?: number;
}

// Read-only pie/donut built on recharts (the repo's charting library), sharing the
// same Pie/Cell pattern as CreativeAllocationChart. Zero-value slices are dropped.
export const PieChart = ({ data, size, innerRadiusRatio = 0 }: PieChartProps) => {
  const slices = data.filter(slice => slice.value > 0);
  const outerRadius = size / 2;
  return (
    <RechartsPieChart width={size} height={size}>
      <Pie
        data={slices}
        dataKey='value'
        nameKey='name'
        cx='50%'
        cy='50%'
        innerRadius={outerRadius * innerRadiusRatio}
        outerRadius={outerRadius}
        stroke='white'
        strokeWidth={1}
        isAnimationActive={false}
      >
        {slices.map(slice => (
          <Cell key={slice.name} fill={slice.color} />
        ))}
      </Pie>
    </RechartsPieChart>
  );
};
